import {VcrEntity} from '@app/models/vcr-entity/entity';

export class Group extends VcrEntity<any> {

  get id(): number {
    return this.data.id;
  }

  set id(id) {
    this.data.id = id;
  }

  get groupId(): number {
    return this.data.roomNum;
  }

  set groupId(groupId) {
    this.data.roomNum = groupId;
  }

  get topicId(): number {
    return this.data.topicId;
  }

  set topicId(topicId) {
    this.data.topicId = topicId;
  }

  get title(): string {
    return this.data.title;
  }

  set title(title) {
    this.data.title = title;
  }

  get isTeacherGroup(): boolean {
    return this.data.isTeacherGroup;
  }

  set isTeacherGroup(isTeacherGroup) {
    this.data.isTeacherGroup = isTeacherGroup;
  }
}
